import { setSelectRow } from "@global-state/pages/admin/customers/slice";
import { useGetAllUsersQuery } from "@RTKQuery/admin/customers/customers";
import { Checkbox } from "@ui";
import { useAppDispatch, useAppSelector } from "store/hooks";

export function CheckboxAll() {
    const selectRows = useAppSelector(state => state.customersAdminPage.selectRows)

    const dispatch = useAppDispatch();

    const { activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeFilter } = useAppSelector(state => state.customersAdminPage);

    const { data } = useGetAllUsersQuery({
        limit: activePaginationLimit,
        page: activePaginationPage,
        search: activeSearchIdParameter,
        is_active: activeFilter
    });

    return (
        <Checkbox
            checked={data?.users.length === selectRows.length}
            onChange={() => {
                if (data?.users.length === selectRows.length) {
                    dispatch(setSelectRow([]));
                } else {
                    dispatch(setSelectRow(data?.users.map(item => item.id) || []));
                }
            }}
        />
    )
}